import { OPEN_POPUP, CLOSE_POPUP, CLOSE_ALL_POPUPS } from 'store/actions/actionTypes';
import {
  AUTH,
  WALLET,
  CONTRACT,
  BET_HISTORY,
  BLOCKCHAIN_SYNC,
  LOGOUT_ALERT,
  CHANNEL_CREATION,
  REQUEST_CHANNEL_CREATE,
} from 'constants/popups';

const defaultState = {
  [AUTH]: false,
  [CONTRACT]: false,
  [WALLET]: false,
  [BET_HISTORY]: false,
  [BLOCKCHAIN_SYNC]: false,
  [LOGOUT_ALERT]: false,
  [CHANNEL_CREATION]: false,
  [REQUEST_CHANNEL_CREATE]: false,
};

function popupReducer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_POPUP:
      return {
        ...state,
        [action.payload]: true,
      };
    case CLOSE_POPUP:
      return {
        ...state,
        [action.payload]: false,
      };
    case CLOSE_ALL_POPUPS:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}

export default popupReducer;
